(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-home-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.pv-hp').forEach(function (s) {
    var slides = s.querySelectorAll('.pv-hp__slide'), thumbs = s.querySelectorAll('.pv-hp__thumb');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-i');
        slides.forEach(function (sl) { sl.classList.toggle('is-active', sl.getAttribute('data-i') === i); });
        thumbs.forEach(function (th) { th.classList.toggle('is-active', th === t); });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-journey"] && !Shopify.designMode) return;
  try {
    
(function () {
  var secs = document.querySelectorAll('.pv-journey');
  if (!secs.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  secs.forEach(function (sec) {
    sec.classList.add('pv-anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.disconnect(); } });
    }, { threshold: 0.12 });
    io.observe(sec);
    setTimeout(function () { sec.classList.add('is-in'); }, 2500);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-main-duo"]) return;
  try {
    
(function () {
  var root = document.querySelector('.pv-main');
  if (!root) return;
  var slides = root.querySelectorAll('.pv-gallery__slide');
  var thumbs = root.querySelectorAll('.pv-gallery__thumb');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      var i = t.getAttribute('data-index');
      slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-index') === i); });
      thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
    });
  });

  /* --- legenda da galeria --- */
  var cap = root.querySelector('.pv-gallery__cap');
  if (cap) {
    var setCap = function (btn) { cap.textContent = (btn && btn.getAttribute('data-cap')) || ''; };
    setCap(root.querySelector('.pv-gallery__thumb'));
    root.querySelectorAll('.pv-gallery__thumb').forEach(function (t) {
      t.addEventListener('click', function () { setCap(t); });
    });
  }

  /* --- barra de compra fixa --- */
  var bar = root.querySelector('.pv-stickybar');
  var mainCta = root.querySelector('.pv-cta');
  if (bar && mainCta) {
    bar.hidden = false;
    var priceEl = bar.querySelector('.pv-stickybar__price');
    var syncPrice = function () {
      var sel = root.querySelector('.pv-offer input:checked');
      var box = (sel && sel.closest('.pv-offer')) || root.querySelector('.pv-offer');
      var p = box && box.querySelector('.pv-offer__price');
      if (p && priceEl) priceEl.textContent = (p.childNodes[0] ? p.childNodes[0].textContent : p.textContent).trim();
    };
    syncPrice();
    root.querySelectorAll('.pv-offer input').forEach(function (i) {
      i.addEventListener('change', syncPrice);
    });
    bar.querySelector('.pv-stickybar__btn').addEventListener('click', function () { mainCta.click(); });
    var toggle = function () {
      var r = mainCta.getBoundingClientRect();
      var past = r.bottom < 0;
      var atFoot = (window.innerHeight + window.scrollY) > (document.body.scrollHeight - 240);
      bar.classList.toggle('is-on', past && !atFoot);
    };
    toggle();
    window.addEventListener('scroll', toggle, { passive: true });
    window.addEventListener('resize', toggle);
  }

  var clock = root.querySelector('.pv-timer__clock');
  if (clock) {
    var mins = parseInt(clock.getAttribute('data-minutes') || '240', 10);
    var key = 'pv_timer_end';
    var end = parseInt(sessionStorage.getItem(key) || '0', 10);
    if (!end || end < Date.now()) { end = Date.now() + mins * 60000; sessionStorage.setItem(key, String(end)); }
    var tick = function () {
      var d = Math.max(0, end - Date.now());
      var h = Math.floor(d / 3600000), m = Math.floor((d % 3600000) / 60000), s = Math.floor((d % 60000) / 1000);
      clock.textContent = [h, m, s].map(function (n) { return String(n).padStart(2, '0'); }).join(':');
    };
    tick(); setInterval(tick, 1000);
  }
  var viewers = root.querySelector('.pv-viewers__n');
  if (viewers) {
    var mn = parseInt(viewers.getAttribute('data-min') || '30', 10), mx = parseInt(viewers.getAttribute('data-max') || '60', 10);
    var cur = mn + Math.floor(Math.random() * (mx - mn));
    var bump = function () { cur = Math.min(mx, Math.max(mn, cur + (Math.random() > 0.5 ? 1 : -1))); viewers.textContent = cur + ' personnes'; };
    bump(); setInterval(bump, 7000);
  }
  var offers = root.querySelectorAll('.pv-offer');
  offers.forEach(function (l) {
    var inp = l.querySelector('input');
    l.addEventListener('mousedown', function () { l.setAttribute('data-was', inp.checked ? '1' : '0'); });
    l.addEventListener('click', function (e) {
      if (e.target === inp) return;
      if (l.getAttribute('data-was') === '1') { e.preventDefault(); inp.checked = false; if (typeof syncGifts === 'function') syncGifts(); }
    });
  });

  /* --- cadeaux: verrouillage par palier (1 appareil, 2 pack du milieu, 3 premium) --- */
  var gifts = root.querySelectorAll('.pv-gift');
  var syncGifts = function () {
    var sel = root.querySelector('.pv-offer input:checked');
    var lvl = sel ? parseInt(sel.closest('.pv-offer').getAttribute('data-level') || '1', 10) : 0;
    root.setAttribute('data-offer-level', String(lvl));
    var open = 0;
    gifts.forEach(function (g) { var m = parseInt(g.getAttribute('data-min') || '2', 10); var ok = lvl >= m; g.classList.toggle('is-locked', !ok); if (ok) open++; });
    var tab = root.querySelector('.pv-gifts__tab');
    if (tab) tab.classList.toggle('is-none', open === 0);
  };
  syncGifts();
  root.querySelectorAll('.pv-offer input').forEach(function (i) { i.addEventListener('change', syncGifts); });

  /* --- couleur: demo dans la galerie + variante par couleur --- */
  var parseMap = function (s) { var m = {}; (s || '').split(';').forEach(function (kv) { var i = kv.indexOf('='); if (i > 0) m[kv.slice(0, i)] = kv.slice(i + 1); }); return m; };
  var proMap = parseMap(root.getAttribute('data-pro-map')), perfMap = parseMap(root.getAttribute('data-perf-map')), eliteMap = parseMap(root.getAttribute('data-elite-map'));
  var currentColor = function () { var c = root.querySelector('input[name="pv-color"]:checked'); return c ? c.value : ''; };
  var colorSlide = root.querySelector('.pv-gallery__slide--color');
  var colorCur = root.querySelector('.pv-colors__current');
  var showColor = function (lab, animate) {
    root.querySelectorAll('.pv-color').forEach(function (x) { x.classList.toggle('is-on', x === lab); });
    if (colorCur) colorCur.textContent = lab.getAttribute('data-color') || '';
    var img = lab.getAttribute('data-image');
    if (img && colorSlide) {
      var el = colorSlide.querySelector('img');
      el.src = img; el.alt = lab.getAttribute('data-color') || '';
      slides.forEach(function (s) { s.classList.remove('is-active'); });
      colorSlide.classList.add('is-active');
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      if (cap) cap.textContent = (lab.getAttribute('data-color') || '').toUpperCase();
      if (animate) { colorSlide.classList.remove('is-pop'); void colorSlide.offsetWidth; colorSlide.classList.add('is-pop'); }
    }
    [['solo', 'data-thumb-solo'], ['performance', 'data-thumb-perf'], ['elite', 'data-thumb-elite']].forEach(function (pair) {
      var u = lab.getAttribute(pair[1]); if (!u) return;
      var im = root.querySelector('.pv-offer[data-offer="' + pair[0] + '"] .pv-offer__thumb img');
      if (im && im.getAttribute('src') !== u) { im.removeAttribute('srcset'); im.src = u; im.classList.remove('is-swap'); void im.offsetWidth; im.classList.add('is-swap'); }
    });
  };
  root.querySelectorAll('.pv-color input').forEach(function (i) {
    i.addEventListener('change', function () { showColor(i.closest('.pv-color'), true); });
  });
  thumbs.forEach(function (tb) { tb.addEventListener('click', function () { if (colorSlide) colorSlide.classList.remove('is-active'); }); });

  /* --- UGC vídeo: clique = play/pause, sem controles nativos, um por vez --- */
  var ugcVideos = root.querySelectorAll('.pv-ugc__item--video');
  ugcVideos.forEach(function (card) {
    var v = card.querySelector('video');
    if (!v) return;
    v.controls = false; v.removeAttribute('controls');
    v.addEventListener('play', function () { card.classList.add('is-playing'); ugcVideos.forEach(function (o) { if (o !== card) { var ov = o.querySelector('video'); if (ov && !ov.paused) ov.pause(); } }); });
    v.addEventListener('pause', function () { card.classList.remove('is-playing'); });
    v.addEventListener('ended', function () { card.classList.remove('is-playing'); v.currentTime = 0; });
    v.addEventListener('webkitbeginfullscreen', function () { try { v.webkitExitFullscreen(); } catch (e) {} });
    card.addEventListener('click', function (e) {
      e.preventDefault();
      if (v.paused) { v.muted = false; var p = v.play(); if (p && p.catch) p.catch(function () { v.muted = true; v.play().catch(function () {}); }); }
      else { v.pause(); }
    });
    card.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); card.click(); } });
    card.setAttribute('tabindex', '0');
  });
  if ('IntersectionObserver' in window && ugcVideos.length) {
    var uio = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (!en.isIntersecting) { var vv = en.target.querySelector('video'); if (vv && !vv.paused) vv.pause(); } }); }, { threshold: 0.1 });
    ugcVideos.forEach(function (c) { uio.observe(c); });
  }

  /* --- galeria: deslizar no celular + contador + miniatura ativa sempre visível --- */
  (function () {
    var stage = root.querySelector('.pv-gallery__stage');
    var strip = root.querySelector('.pv-gallery__thumbs');
    var list = Array.prototype.slice.call(thumbs);
    if (!stage || !list.length) return;
    var setCount = function () {
      var act = list.findIndex(function (x) { return x.classList.contains('is-active'); });
      if (cap) cap.setAttribute('data-count', act >= 0 ? (act + 1) + ' / ' + list.length : '');
      if (act >= 0 && strip) { var tb = list[act]; var left = tb.offsetLeft - (strip.clientWidth - tb.offsetWidth) / 2; strip.scrollTo({ left: left, behavior: 'smooth' }); }
    };
    var go = function (dir) {
      var act = list.findIndex(function (x) { return x.classList.contains('is-active'); });
      var next = act < 0 ? 0 : Math.min(list.length - 1, Math.max(0, act + dir));
      if (next === act) return;
      stage.style.setProperty('--pv-dir', dir > 0 ? '14px' : '-14px');
      list[next].click();
    };
    list.forEach(function (tb) { tb.addEventListener('click', function () { setTimeout(setCount, 0); }); });
    var x0 = null, y0 = null, t0 = 0;
    stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; t0 = Date.now(); }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0]; var dx = t.clientX - x0, dy = t.clientY - y0; x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3 && Date.now() - t0 < 700) go(dx < 0 ? 1 : -1);
    }, { passive: true });
    setCount();
  })();
  var cta = root.querySelector('.pv-cta');
  cta.addEventListener('click', function () {
    var offer = (root.querySelector('input[name="pv-offer"]:checked') || {}).value || 'performance';
    var proId = root.getAttribute('data-pro-variant');
    var eliteId = root.getAttribute('data-elite-variant');
    var perfId = root.getAttribute('data-perf-variant');
    var perfTitle = root.getAttribute('data-perf-title') || 'Pack Performance';
    var eliteTitle = root.getAttribute('data-elite-title') || 'Pack Elite';
    var color = currentColor();
    var pick = function (map, fallback) { var id = map && color ? map[color] : null; return id || fallback; };
    var proPick = pick(proMap, proId), perfPick = pick(perfMap, perfId || proId), elitePick = pick(eliteMap, eliteId);
    var items = [];
    var colorProp = color ? { Couleur: color } : {};
    if (offer === 'elite' && elitePick) { items.push({ id: parseInt(elitePick, 10), quantity: 1, properties: Object.assign({ Offre: eliteTitle }, colorProp) }); }
    else if (offer === 'performance') { items.push({ id: parseInt(perfPick, 10), quantity: 1, properties: Object.assign({ Offre: perfTitle, Bonus: 'Spray + guides offerts' }, colorProp) }); }
    else { items.push({ id: parseInt(proPick, 10), quantity: 1, properties: Object.assign({ Offre: 'Appareil seul' }, colorProp) }); }
    cta.disabled = true;
    fetch('/cart/clear.js', { method: 'POST' }).then(function () {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) });
    }).then(function (r) { if (!r.ok) throw new Error('add'); window.location.href = '/checkout'; })
      .catch(function () { cta.disabled = false; window.location.href = '/cart'; });
  });
})();

  /* Data de entrega calculada: hoje + N dias uteis, em frances. */
  (function () {
    document.querySelectorAll('.pv-delivery').forEach(function (el) {
      var dias = parseInt(el.getAttribute('data-days'), 10);
      if (!dias || dias < 1) dias = 5;
      var d = new Date();
      var somados = 0;
      while (somados < dias) {
        d.setDate(d.getDate() + 1);
        var wd = d.getDay();
        if (wd !== 0 && wd !== 6) somados++;
      }
      var alvo = el.querySelector('.pv-delivery__date');
      if (!alvo) return;
      try {
        alvo.textContent = d.toLocaleDateString('de-DE', { weekday: 'long', day: 'numeric', month: 'long' });
      } catch (e) {
        alvo.textContent = d.toLocaleDateString();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-main"]) return;
  try {
    
(function () {
  var root = document.querySelector('.pv-main');
  if (!root) return;
  var slides = root.querySelectorAll('.pv-gallery__slide');
  var thumbs = root.querySelectorAll('.pv-gallery__thumb');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      var i = t.getAttribute('data-index');
      slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-index') === i); });
      thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
    });
  });

  /* --- legenda da galeria --- */
  var cap = root.querySelector('.pv-gallery__cap');
  if (cap) {
    var setCap = function (btn) { cap.textContent = (btn && btn.getAttribute('data-cap')) || ''; };
    setCap(root.querySelector('.pv-gallery__thumb'));
    root.querySelectorAll('.pv-gallery__thumb').forEach(function (t) {
      t.addEventListener('click', function () { setCap(t); });
    });
  }

  /* --- barra de compra fixa --- */
  var bar = root.querySelector('.pv-stickybar');
  var mainCta = root.querySelector('.pv-cta');
  if (bar && mainCta) {
    bar.hidden = false;
    var priceEl = bar.querySelector('.pv-stickybar__price');
    var syncPrice = function () {
      var sel = root.querySelector('.pv-offer input:checked');
      var box = (sel && sel.closest('.pv-offer')) || root.querySelector('.pv-offer');
      var p = box && box.querySelector('.pv-offer__price');
      if (p && priceEl) priceEl.textContent = (p.childNodes[0] ? p.childNodes[0].textContent : p.textContent).trim();
    };
    syncPrice();
    root.querySelectorAll('.pv-offer input').forEach(function (i) {
      i.addEventListener('change', syncPrice);
    });
    bar.querySelector('.pv-stickybar__btn').addEventListener('click', function () { mainCta.click(); });
    var toggle = function () {
      var r = mainCta.getBoundingClientRect();
      var past = r.bottom < 0;
      var atFoot = (window.innerHeight + window.scrollY) > (document.body.scrollHeight - 240);
      bar.classList.toggle('is-on', past && !atFoot);
    };
    toggle();
    window.addEventListener('scroll', toggle, { passive: true });
    window.addEventListener('resize', toggle);
  }

  var clock = root.querySelector('.pv-timer__clock');
  if (clock) {
    var mins = parseInt(clock.getAttribute('data-minutes') || '240', 10);
    var key = 'pv_timer_end';
    var end = parseInt(sessionStorage.getItem(key) || '0', 10);
    if (!end || end < Date.now()) { end = Date.now() + mins * 60000; sessionStorage.setItem(key, String(end)); }
    var tick = function () {
      var d = Math.max(0, end - Date.now());
      var h = Math.floor(d / 3600000), m = Math.floor((d % 3600000) / 60000), s = Math.floor((d % 60000) / 1000);
      clock.textContent = [h, m, s].map(function (n) { return String(n).padStart(2, '0'); }).join(':');
    };
    tick(); setInterval(tick, 1000);
  }
  var viewers = root.querySelector('.pv-viewers__n');
  if (viewers) {
    var mn = parseInt(viewers.getAttribute('data-min') || '30', 10), mx = parseInt(viewers.getAttribute('data-max') || '60', 10);
    var cur = mn + Math.floor(Math.random() * (mx - mn));
    var bump = function () { cur = Math.min(mx, Math.max(mn, cur + (Math.random() > 0.5 ? 1 : -1))); viewers.textContent = cur + ' personnes'; };
    bump(); setInterval(bump, 7000);
  }
  var offers = root.querySelectorAll('.pv-offer');
  offers.forEach(function (l) {
    var inp = l.querySelector('input');
    l.addEventListener('mousedown', function () { l.setAttribute('data-was', inp.checked ? '1' : '0'); });
    l.addEventListener('click', function (e) {
      if (e.target === inp) return;
      if (l.getAttribute('data-was') === '1') { e.preventDefault(); inp.checked = false; if (typeof syncGifts === 'function') syncGifts(); }
    });
  });

  /* --- cadeaux: verrouillage par palier (1 appareil, 2 pack du milieu, 3 premium) --- */
  var gifts = root.querySelectorAll('.pv-gift');
  var syncGifts = function () {
    var sel = root.querySelector('.pv-offer input:checked');
    var lvl = sel ? parseInt(sel.closest('.pv-offer').getAttribute('data-level') || '1', 10) : 0;
    root.setAttribute('data-offer-level', String(lvl));
    var open = 0;
    gifts.forEach(function (g) { var m = parseInt(g.getAttribute('data-min') || '2', 10); var ok = lvl >= m; g.classList.toggle('is-locked', !ok); if (ok) open++; });
    var tab = root.querySelector('.pv-gifts__tab');
    if (tab) tab.classList.toggle('is-none', open === 0);
  };
  syncGifts();
  root.querySelectorAll('.pv-offer input').forEach(function (i) { i.addEventListener('change', syncGifts); });

  /* --- couleur: demo dans la galerie + variante par couleur --- */
  var parseMap = function (s) { var m = {}; (s || '').split(';').forEach(function (kv) { var i = kv.indexOf('='); if (i > 0) m[kv.slice(0, i)] = kv.slice(i + 1); }); return m; };
  var proMap = parseMap(root.getAttribute('data-pro-map')), perfMap = parseMap(root.getAttribute('data-perf-map')), eliteMap = parseMap(root.getAttribute('data-elite-map'));
  var currentColor = function () { var c = root.querySelector('input[name="pv-color"]:checked'); return c ? c.value : ''; };
  var colorSlide = root.querySelector('.pv-gallery__slide--color');
  var colorCur = root.querySelector('.pv-colors__current');
  var showColor = function (lab, animate) {
    root.querySelectorAll('.pv-color').forEach(function (x) { x.classList.toggle('is-on', x === lab); });
    if (colorCur) colorCur.textContent = lab.getAttribute('data-color') || '';
    var img = lab.getAttribute('data-image');
    if (img && colorSlide) {
      var el = colorSlide.querySelector('img');
      el.src = img; el.alt = lab.getAttribute('data-color') || '';
      slides.forEach(function (s) { s.classList.remove('is-active'); });
      colorSlide.classList.add('is-active');
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      if (cap) cap.textContent = (lab.getAttribute('data-color') || '').toUpperCase();
      if (animate) { colorSlide.classList.remove('is-pop'); void colorSlide.offsetWidth; colorSlide.classList.add('is-pop'); }
    }
    [['solo', 'data-thumb-solo'], ['performance', 'data-thumb-perf'], ['elite', 'data-thumb-elite']].forEach(function (pair) {
      var u = lab.getAttribute(pair[1]); if (!u) return;
      var im = root.querySelector('.pv-offer[data-offer="' + pair[0] + '"] .pv-offer__thumb img');
      if (im && im.getAttribute('src') !== u) { im.removeAttribute('srcset'); im.src = u; im.classList.remove('is-swap'); void im.offsetWidth; im.classList.add('is-swap'); }
    });
  };
  root.querySelectorAll('.pv-color input').forEach(function (i) {
    i.addEventListener('change', function () { showColor(i.closest('.pv-color'), true); });
  });
  thumbs.forEach(function (tb) { tb.addEventListener('click', function () { if (colorSlide) colorSlide.classList.remove('is-active'); }); });

  /* --- UGC vídeo: clique = play/pause, sem controles nativos, um por vez --- */
  var ugcVideos = root.querySelectorAll('.pv-ugc__item--video');
  ugcVideos.forEach(function (card) {
    var v = card.querySelector('video');
    if (!v) return;
    v.controls = false; v.removeAttribute('controls');
    v.addEventListener('play', function () { card.classList.add('is-playing'); ugcVideos.forEach(function (o) { if (o !== card) { var ov = o.querySelector('video'); if (ov && !ov.paused) ov.pause(); } }); });
    v.addEventListener('pause', function () { card.classList.remove('is-playing'); });
    v.addEventListener('ended', function () { card.classList.remove('is-playing'); v.currentTime = 0; });
    v.addEventListener('webkitbeginfullscreen', function () { try { v.webkitExitFullscreen(); } catch (e) {} });
    card.addEventListener('click', function (e) {
      e.preventDefault();
      if (v.paused) { v.muted = false; var p = v.play(); if (p && p.catch) p.catch(function () { v.muted = true; v.play().catch(function () {}); }); }
      else { v.pause(); }
    });
    card.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); card.click(); } });
    card.setAttribute('tabindex', '0');
  });
  if ('IntersectionObserver' in window && ugcVideos.length) {
    var uio = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (!en.isIntersecting) { var vv = en.target.querySelector('video'); if (vv && !vv.paused) vv.pause(); } }); }, { threshold: 0.1 });
    ugcVideos.forEach(function (c) { uio.observe(c); });
  }

  /* --- galeria: deslizar no celular + contador + miniatura ativa sempre visível --- */
  (function () {
    var stage = root.querySelector('.pv-gallery__stage');
    var strip = root.querySelector('.pv-gallery__thumbs');
    var list = Array.prototype.slice.call(thumbs);
    if (!stage || !list.length) return;
    var setCount = function () {
      var act = list.findIndex(function (x) { return x.classList.contains('is-active'); });
      if (cap) cap.setAttribute('data-count', act >= 0 ? (act + 1) + ' / ' + list.length : '');
      if (act >= 0 && strip) { var tb = list[act]; var left = tb.offsetLeft - (strip.clientWidth - tb.offsetWidth) / 2; strip.scrollTo({ left: left, behavior: 'smooth' }); }
    };
    var go = function (dir) {
      var act = list.findIndex(function (x) { return x.classList.contains('is-active'); });
      var next = act < 0 ? 0 : Math.min(list.length - 1, Math.max(0, act + dir));
      if (next === act) return;
      stage.style.setProperty('--pv-dir', dir > 0 ? '14px' : '-14px');
      list[next].click();
    };
    list.forEach(function (tb) { tb.addEventListener('click', function () { setTimeout(setCount, 0); }); });
    var x0 = null, y0 = null, t0 = 0;
    stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; t0 = Date.now(); }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0]; var dx = t.clientX - x0, dy = t.clientY - y0; x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3 && Date.now() - t0 < 700) go(dx < 0 ? 1 : -1);
    }, { passive: true });
    setCount();
  })();
  var cta = root.querySelector('.pv-cta');
  cta.addEventListener('click', function () {
    var offer = (root.querySelector('input[name="pv-offer"]:checked') || {}).value || 'performance';
    var proId = root.getAttribute('data-pro-variant');
    var eliteId = root.getAttribute('data-elite-variant');
    var perfId = root.getAttribute('data-perf-variant');
    var perfTitle = root.getAttribute('data-perf-title') || 'Pack Performance';
    var eliteTitle = root.getAttribute('data-elite-title') || 'Pack Elite';
    var color = currentColor();
    var pick = function (map, fallback) { var id = map && color ? map[color] : null; return id || fallback; };
    var proPick = pick(proMap, proId), perfPick = pick(perfMap, perfId || proId), elitePick = pick(eliteMap, eliteId);
    var items = [];
    var colorProp = color ? { Couleur: color } : {};
    if (offer === 'elite' && elitePick) { items.push({ id: parseInt(elitePick, 10), quantity: 1, properties: Object.assign({ Offre: eliteTitle }, colorProp) }); }
    else if (offer === 'performance') { items.push({ id: parseInt(perfPick, 10), quantity: 1, properties: Object.assign({ Offre: perfTitle, Bonus: 'Guides + livre offerts' }, colorProp) }); }
    else { items.push({ id: parseInt(proPick, 10), quantity: 1, properties: Object.assign({ Offre: 'Appareil seul' }, colorProp) }); }
    cta.disabled = true;
    fetch('/cart/clear.js', { method: 'POST' }).then(function () {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) });
    }).then(function (r) { if (!r.ok) throw new Error('add'); window.location.href = '/checkout'; })
      .catch(function () { cta.disabled = false; window.location.href = '/cart'; });
  });
})();

  /* Data de entrega calculada: hoje + N dias uteis, em frances. */
  (function () {
    document.querySelectorAll('.pv-delivery').forEach(function (el) {
      var dias = parseInt(el.getAttribute('data-days'), 10);
      if (!dias || dias < 1) dias = 5;
      var d = new Date();
      var somados = 0;
      while (somados < dias) {
        d.setDate(d.getDate() + 1);
        var wd = d.getDay();
        if (wd !== 0 && wd !== 6) somados++;
      }
      var alvo = el.querySelector('.pv-delivery__date');
      if (!alvo) return;
      try {
        alvo.textContent = d.toLocaleDateString('de-DE', { weekday: 'long', day: 'numeric', month: 'long' });
      } catch (e) {
        alvo.textContent = d.toLocaleDateString();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-multirow"] && !Shopify.designMode) return;
  try {
    
(function () {
  var rows = document.querySelectorAll('.pv-mr__row');
  if (!rows.length) return;
  if (!('IntersectionObserver' in window)) { rows.forEach(function (r) { r.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.2 });
  rows.forEach(function (r) { io.observe(r); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  var btn = document.querySelector('.pv-reviews__more-btn');
  if (!btn) return;
  btn.addEventListener('click', function () {
    document.querySelectorAll('.pv-review.is-hidden').forEach(function (el, i) { if (i < 6) el.classList.remove('is-hidden'); });
    if (!document.querySelector('.pv-review.is-hidden')) btn.parentNode.removeChild(btn);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-stats"] && !Shopify.designMode) return;
  try {
    
(function () {
  var rings = document.querySelectorAll('.pv-stats__ring');
  if (!rings.length) return;
  /* O numero final ja esta no HTML. A animacao so acontece se der tempo,
     e dura 380 ms — nunca pode ser lida como 0 %. */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  var run = function (ring) {
    var target = parseInt(ring.getAttribute('data-target') || '0', 10);
    var num = ring.querySelector('.pv-stats__num');
    var start = null, dur = 380;
    var ease = function (t) { return 1 - Math.pow(1 - t, 3); };
    var step = function (ts) {
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / dur);
      var v = Math.round(target * ease(p));
      num.textContent = v;
      ring.style.setProperty('--pv-pct', v);
      if (p < 1) requestAnimationFrame(step);
      else { num.textContent = target; ring.style.setProperty('--pv-pct', target); }
    };
    requestAnimationFrame(step);
  };
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      run(e.target);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
  rings.forEach(function (r) { io.observe(r); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-steps"] && !Shopify.designMode) return;
  try {
    
(function () {
  var secs = document.querySelectorAll('.pv-steps');
  if (!secs.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  secs.forEach(function (sec) {
    if (!reduce && 'IntersectionObserver' in window) {
      sec.classList.add('pv-anim');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.disconnect(); } });
      }, { threshold: 0.15 });
      io.observe(sec);
      setTimeout(function () { sec.classList.add('is-in'); }, 2500);
    }
    if ('IntersectionObserver' in window) {
      sec.querySelectorAll('video').forEach(function (video) {
        var vio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              if (!video.getAttribute('src') && video.getAttribute('data-src')) { video.src = video.getAttribute('data-src'); video.load(); }
              var p = video.play(); if (p && p.catch) p.catch(function () {});
            }
            else { video.pause(); }
          });
        }, { threshold: 0.25 });
        vio.observe(video);
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-tech"] && !Shopify.designMode) return;
  try {
    
(function () {
  var secs = document.querySelectorAll('.pv-tech');
  if (!secs.length) return;
  if (!('IntersectionObserver' in window)) { secs.forEach(function (s) { s.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.35 });
  secs.forEach(function (s) { io.observe(s); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  var secs = document.querySelectorAll('.pv-testi');
  if (!secs.length) return;
  if (!('IntersectionObserver' in window)) { secs.forEach(function (s) { s.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.15 });
  secs.forEach(function (s) { io.observe(s); });
  document.querySelectorAll('.pv-testi__carousel').forEach(function (c) {
    var track = c.querySelector('.pv-testi__grid');
    var step = function () { var card = track.querySelector('.pv-testi__card'); return card ? card.getBoundingClientRect().width + 18 : 320; };
    c.querySelector('.pv-testi__arrow--prev').addEventListener('click', function () { if (track.scrollLeft <= 2) { track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' }); } else { track.scrollBy({ left: -step(), behavior: 'smooth' }); } });
    c.querySelector('.pv-testi__arrow--next').addEventListener('click', function () { if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) { track.scrollTo({ left: 0, behavior: 'smooth' }); } else { track.scrollBy({ left: step(), behavior: 'smooth' }); } });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-timeline"] && !Shopify.designMode) return;
  try {
    
(function () {
  var secs = document.querySelectorAll('.pv-timeline');
  if (!secs.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return; /* conteudo ja visivel por padrao */
  secs.forEach(function (s) { s.classList.add('pv-anim'); });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  secs.forEach(function (s) { io.observe(s); });
  /* rede de seguranca: em 2,5 s tudo aparece, aconteca o que acontecer */
  setTimeout(function () { secs.forEach(function (s) { s.classList.add('is-in'); }); }, 2500);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-video-split"] && !Shopify.designMode) return;
  try {
    
(function () {
  var secs = document.querySelectorAll('.pv-vs');
  if (!secs.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  secs.forEach(function (sec) {
    var video = sec.querySelector('video');
    if (!reduce && 'IntersectionObserver' in window) {
      sec.classList.add('pv-anim');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { sec.classList.add('is-in'); io.disconnect(); }
        });
      }, { threshold: 0.18 });
      io.observe(sec);
      setTimeout(function () { sec.classList.add('is-in'); }, 2500);
    }
    if (video && 'IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            if (!video.getAttribute('src') && video.getAttribute('data-src')) { video.src = video.getAttribute('data-src'); video.load(); }
            var p = video.play(); if (p && p.catch) p.catch(function () {});
          }
          else { video.pause(); }
        });
      }, { threshold: 0.25 });
      vio.observe(video);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pvc-page"]) return;
  try {
    
(function(){
  var root=document.querySelector('.pvc');if(!root)return;
  var stage=document.getElementById('pvcStage');var thumbs=Array.prototype.slice.call(document.querySelectorAll('#pvcThumbs button'));
  function showThumb(b){if(!b||!stage)return;stage.classList.add('is-fading');setTimeout(function(){stage.removeAttribute('srcset');stage.src=b.getAttribute('data-src');stage.onload=function(){stage.classList.remove('is-fading');};},120);thumbs.forEach(function(x){x.classList.toggle('on',x===b);});try{b.scrollIntoView({block:'nearest',inline:'center',behavior:'smooth'});}catch(e){}}
  thumbs.forEach(function(b){b.addEventListener('click',function(){showThumb(b);});});
  (function(){var st=root.querySelector('.pvc-gal__stage'),x0=null,y0=null;if(!st)return;st.addEventListener('touchstart',function(e){var t=e.touches[0];x0=t.clientX;y0=t.clientY;},{passive:true});st.addEventListener('touchend',function(e){if(x0===null)return;var t=e.changedTouches[0],dx=t.clientX-x0,dy=t.clientY-y0;x0=null;if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)*1.3){var i=thumbs.findIndex(function(b){return b.classList.contains('on');});showThumb(thumbs[Math.max(0,Math.min(thumbs.length-1,i+(dx<0?1:-1)))]);}},{passive:true});})();
  (function(){var track=document.getElementById('pvcMq');if(!track)return;var wrap=track.parentNode;var x=0,last=null,speed=42;function gw(){var g=track.querySelector('.pvc-mq__g');return g?g.getBoundingClientRect().width:0;}
  function fill(){var w=gw();if(!w)return;var n=0;while(track.scrollWidth<wrap.clientWidth+2*w&&n<12){track.appendChild(track.querySelector('.pvc-mq__g').cloneNode(true));n++;}}
  fill();window.addEventListener('resize',fill);
  function step(t){if(last===null)last=t;var dt=Math.min(64,t-last);last=t;x-=speed*dt/1000;var w=gw();if(w&&x<=-w)x+=w;track.style.transform='translate3d('+x+'px,0,0)';requestAnimationFrame(step);}
  requestAnimationFrame(step);})();
  var barPrice=document.getElementById('pvcBarPrice');var offers=root.querySelectorAll('input[name="pvc-offer"]');
  var ov=document.getElementById('pvcOv'),ovImg=document.getElementById('pvcOvImg');
  function syncOv(sel){if(!ov)return;var k=sel==='2'?'2':'1';var src=ov.getAttribute('data-img'+k);if(ovImg&&src){ovImg.removeAttribute('srcset');ovImg.classList.add('is-fading');setTimeout(function(){ovImg.src=src;ovImg.onload=function(){ovImg.classList.remove('is-fading');};},120);}
    var L=document.getElementById('pvcOvLeft'),M=document.getElementById('pvcOvMain'),C=document.getElementById('pvcOvCmp');if(L&&ov.getAttribute('data-left'+k))L.textContent=ov.getAttribute('data-left'+k);if(M&&ov.getAttribute('data-main'+k))M.textContent=ov.getAttribute('data-main'+k);if(C&&ov.getAttribute('data-cmp'+k))C.textContent=ov.getAttribute('data-cmp'+k);}
  offers.forEach(function(i){i.addEventListener('change',function(){var box=i.closest('.pvc-offer');var p=box&&box.querySelector('.pvc-p b');if(barPrice&&p)barPrice.textContent=p.textContent;syncOv(i.value);});});
  var dEl=root.querySelector('.pvc-deliv__d');if(dEl){var days=parseInt(dEl.getAttribute('data-days')||'6',10),d=new Date(),n=0;while(n<days){d.setDate(d.getDate()+1);var w=d.getDay();if(w!==0&&w!==6)n++;}try{dEl.textContent=d.toLocaleDateString(root.getAttribute('data-lang')||'fr-FR',{weekday:'long',day:'numeric',month:'long'});}catch(e){dEl.textContent=d.toLocaleDateString();}}
  root.querySelectorAll('.pvc-tabs button').forEach(function(b){b.addEventListener('click',function(){var t=b.getAttribute('data-t');root.querySelectorAll('.pvc-tabs button').forEach(function(x){x.classList.toggle('on',x===b);});root.querySelectorAll('.pvc-mech__t').forEach(function(p){p.hidden=p.getAttribute('data-p')!==t;});root.querySelectorAll('.pvc-mech__media video').forEach(function(v){var on=v.getAttribute('data-p')===t;v.hidden=!on;if(on){try{v.currentTime=0;}catch(e){}v.play().catch(function(){});}else{v.pause();}});});});
  var media=root.querySelector('.pvc-mech__media');if(media&&'IntersectionObserver' in window){new IntersectionObserver(function(es){es.forEach(function(e){var v=media.querySelector('video:not([hidden])');if(!v)return;if(e.isIntersecting){v.play().catch(function(){});}else{v.pause();}});},{threshold:.3}).observe(media);}
  var cta=document.getElementById('pvcCta'),bar=document.getElementById('pvcBar');
  function buy(btn){var sel=(root.querySelector('input[name="pvc-offer"]:checked')||{}).value||'1';var id=parseInt(sel==='2'?root.getAttribute('data-v2'):root.getAttribute('data-v1'),10);var title=sel==='2'?root.getAttribute('data-t2'):root.getAttribute('data-t1');if(!id)return;var pr={};pr[root.getAttribute('data-pk')||'Offre']=title;pr.Bonus=root.getAttribute('data-pb')||'Spray Endurance + guides offerts';btn.disabled=true;
    fetch('/cart/clear.js',{method:'POST'}).then(function(){return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1,properties:pr}]})});}).then(function(r){if(!r.ok)throw new Error('add');window.location.href='/checkout';}).catch(function(){btn.disabled=false;window.location.href='/cart';});}
  if(cta)cta.addEventListener('click',function(){buy(cta);});
  var barBtn=document.getElementById('pvcBarBtn');if(barBtn)barBtn.addEventListener('click',function(){buy(barBtn);});
  (function(){var tr=document.getElementById('pvcRvTrack');if(!tr)return;var cards=Array.prototype.slice.call(tr.children);if(cards.length<2)return;
    var design=!!(window.Shopify&&window.Shopify.designMode);
    if(!design){cards.forEach(function(c){var k=c.cloneNode(true);k.setAttribute('aria-hidden','true');k.removeAttribute('data-shopify-editor-block');tr.appendChild(k);});}
    var half=function(){return tr.scrollWidth/2;};var speed=22,pauseUntil=0,last=null,hold=false,pos=0,driving=false;
    function step(t){if(last===null)last=t;var dt=Math.min(64,t-last);last=t;
      var can=!design&&!hold&&t>pauseUntil&&!document.hidden;
      if(can){if(!driving){pos=tr.scrollLeft;driving=true;}pos+=speed*dt/1000;var h=half();if(pos>=h)pos-=h;tr.scrollLeft=pos;}else{driving=false;}
      requestAnimationFrame(step);}
    requestAnimationFrame(step);
    ['touchstart','pointerdown','mouseenter'].forEach(function(e){tr.addEventListener(e,function(){hold=true;},{passive:true});});
    ['touchend','touchcancel','pointerup','mouseleave'].forEach(function(e){tr.addEventListener(e,function(){hold=false;pauseUntil=performance.now()+5000;},{passive:true});});
    tr.addEventListener('scroll',function(){if(!driving&&!design){var h=half();if(tr.scrollLeft>=h)tr.scrollLeft-=h;}},{passive:true});
    function go(d){pauseUntil=performance.now()+7000;driving=false;var w=cards[0].getBoundingClientRect().width+12;if(d<0&&tr.scrollLeft<w&&!design)tr.scrollLeft+=half();tr.scrollBy({left:d*w,behavior:'smooth'});}
    var l=document.querySelector('.pvc-rvc__arr--l'),r=document.querySelector('.pvc-rvc__arr--r');if(l)l.addEventListener('click',function(){go(-1);});if(r)r.addEventListener('click',function(){go(1);});
  })();
  root.querySelectorAll('[data-cta="pvc-cta-final"]').forEach(function(b){b.addEventListener('click',function(){document.getElementById('pvc-top').scrollIntoView({behavior:'smooth'});});});
  if(bar&&cta){function tog(){var r=cta.getBoundingClientRect();var foot=(window.innerHeight+window.scrollY)>(document.body.scrollHeight-260);bar.classList.toggle('on',r.bottom<0&&!foot);}window.addEventListener('scroll',tog,{passive:true});tog();}
})();

  } catch(e) { console.error(e); }
})();
})();
